import { useState, useEffect, type ImgHTMLAttributes, type ReactNode } from 'react';
import { photoApi } from '../api/photoApi';

interface ThumbImgProps extends Omit<ImgHTMLAttributes<HTMLImageElement>, 'src'> {
  url: string | null;
  fallback?: ReactNode;
  previewToken?: string;
}

// alt 기본값 "" — 썸네일은 대부분 옆에 현장명·날짜 텍스트가 있는 장식 이미지다. 의미 이미지면 호출부에서 alt 를 넘긴다.
export function ThumbImg({ url, fallback = null, previewToken, style, alt = '', ...imgProps }: ThumbImgProps) {
  const [blobUrl, setBlobUrl] = useState<string | null>(null);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (!url) { setBlobUrl(null); return; }
    const controller = new AbortController();
    let objectUrl: string | null = null;
    setLoaded(false);

    photoApi.getThumb(url, controller.signal, previewToken)
      .then(res => {
        objectUrl = URL.createObjectURL(res.data);
        setBlobUrl(objectUrl);
      })
      .catch(() => { /* 실패(404, abort 포함) 시 fallback 유지 */ });

    return () => {
      controller.abort();
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [url, previewToken]);

  if (!blobUrl) return <>{fallback}</>;
  return (
    <img
      src={blobUrl}
      alt={alt}
      onLoad={() => setLoaded(true)}
      style={{ ...style, opacity: loaded ? 1 : 0, transition: 'opacity .25s ease' }}
      {...imgProps}
    />
  );
}
